import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import awsService from "../services/awsService";
import shareService from "../services/shareService";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import { useStateContext } from "../contexts/ContextProvider";

const GetVideoToken = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { currentColor, currentMode } = useStateContext();
  const [loading, setLoading] = useState(true);
  const getFilename = async () => {
    try {
      const response = await shareService.redirect(params.id);
      if (response.status == "error") {
        setLoading(false);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      if (response) {
        navigate(`/viewvideo/${response}`);
      }
      // } else {
      //   toast.error("Link Expired", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //   });
      // }
    } catch (error) {
      setLoading(false);

      toast.error("Link Expired", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error("Error sharing file:", error);
    }
  };

  useEffect(() => {
    getFilename();
  });
  return (
    <div>
      {loading ? (
        <Loading loading={"loading"} currentColor={currentColor} />
      ) : (
        <>Invalid Link</>
      )}
    </div>
  );
};

export default GetVideoToken;
